(function () {
	if (window.NodeList && !NodeList.prototype.forEach) {
		NodeList.prototype.forEach = Array.prototype.forEach;
	}

	if (!Array.from) {
		Array.from = function (items) {
			return Array.prototype.slice.call(items);
		};
	}

	function twoDigits(value) {
		return value < 10 ? "0" + value : String(value);
	}

	function ready(fn) {
		if (document.readyState === "loading") {
			document.addEventListener("DOMContentLoaded", fn);
		} else {
			fn();
		}
	}

	function setActive(items, activeItem) {
		items.forEach(function (item) {
			item.classList.toggle("is-active", item === activeItem);
		});
	}

	function encodeRequest(data) {
		return Object.keys(data)
			.map(function (key) {
				return encodeURIComponent(key) + "=" + encodeURIComponent(data[key] || "");
			})
			.join("&");
	}

	function plainText(value) {
		var holder = document.createElement("div");
		holder.innerHTML = value || "";
		return holder.textContent || holder.innerText || "";
	}

	function responseError(payload) {
		if (payload && payload._server_messages) {
			try {
				var messages = JSON.parse(payload._server_messages);
				if (messages.length) {
					var message = JSON.parse(messages[0]);
					return plainText(message.message || message);
				}
			} catch (error) {
				return "The request could not be completed.";
			}
		}
		if (payload && typeof payload.message === "string") {
			return plainText(payload.message);
		}
		return "The request could not be completed. Please try again.";
	}

	function postToFrappe(method, data, onSuccess, onError) {
		var request = new XMLHttpRequest();
		request.open("POST", "/api/method/" + method, true);
		request.setRequestHeader(
			"Content-Type",
			"application/x-www-form-urlencoded; charset=UTF-8"
		);
		if (window.frappe && window.frappe.csrf_token) {
			request.setRequestHeader("X-Frappe-CSRF-Token", window.frappe.csrf_token);
		}
		request.onreadystatechange = function () {
			if (request.readyState !== 4) return;
			var payload = null;
			try {
				payload = JSON.parse(request.responseText || "{}");
			} catch (error) {
				payload = {};
			}
			if (request.status >= 200 && request.status < 300) {
				onSuccess(payload.message || payload);
			} else {
				onError(responseError(payload));
			}
		};
		request.onerror = function () {
			onError("The network request did not complete. Please try again.");
		};
		request.send(encodeRequest(data));
	}

	function queryValue(name) {
		var query = window.location.search.substring(1).split("&");
		for (var index = 0; index < query.length; index += 1) {
			var pair = query[index].split("=");
			if (decodeURIComponent(pair[0] || "") === name) {
				return decodeURIComponent((pair[1] || "").replace(/\+/g, " "));
			}
		}
		return "";
	}

	ready(function () {
		var reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
		var header = document.querySelector("[data-eb-header]");
		if (header) {
			var onScroll = function () {
				header.classList.toggle("is-scrolled", window.scrollY > 8);
			};
			onScroll();
			window.addEventListener("scroll", onScroll, { passive: true });
		}

		var menuButton = document.querySelector("[data-eb-menu-button]");
		var mobilePanel = document.querySelector("[data-eb-mobile-panel]");
		if (menuButton && mobilePanel) {
			var setMenu = function (open) {
				mobilePanel.classList.toggle("is-open", open);
				menuButton.setAttribute("aria-expanded", String(open));
				menuButton.setAttribute(
					"aria-label",
					open ? "Close navigation" : "Open navigation"
				);
			};
			menuButton.addEventListener("click", function () {
				setMenu(!mobilePanel.classList.contains("is-open"));
			});
			mobilePanel.querySelectorAll("a").forEach(function (link) {
				link.addEventListener("click", function () {
					setMenu(false);
				});
			});
			document.addEventListener("keydown", function (event) {
				if (event.key === "Escape") setMenu(false);
			});
		}

		document.querySelectorAll("[data-eb-relief-card]").forEach(function (card) {
			var toggle = card.querySelector("[data-eb-relief-toggle]");
			var label = card.querySelector("[data-eb-relief-label]");
			if (!toggle) return;

			toggle.addEventListener("click", function () {
				var open = card.classList.toggle("is-relief");
				toggle.setAttribute("aria-expanded", String(open));
				if (label) label.textContent = open ? "Show the pressure" : "Show the relief";
			});
		});

		document.querySelectorAll("[data-eb-pathways]").forEach(function (root) {
			var track = root.querySelector("[data-eb-path-track]");
			var panels = Array.from(root.querySelectorAll("[data-eb-path-panel]"));
			var dots = Array.from(root.querySelectorAll("[data-eb-path-dot]"));
			var previous = root.querySelector("[data-eb-path-prev]");
			var next = root.querySelector("[data-eb-path-next]");
			var count = root.querySelector("[data-eb-path-count]");
			var current = 0;
			var scrollFrame = null;

			if (!track || !panels.length) return;

			var updatePathState = function (index) {
				current = Math.max(0, Math.min(panels.length - 1, index));
				dots.forEach(function (dot, dotIndex) {
					dot.classList.toggle("is-active", dotIndex === current);
					dot.setAttribute("aria-current", dotIndex === current ? "true" : "false");
				});
				if (count) {
					count.textContent =
						twoDigits(current + 1) + " / " + twoDigits(panels.length);
				}
				if (previous) previous.disabled = current === 0;
				if (next) next.disabled = current === panels.length - 1;
			};

			var scrollToPath = function (index) {
				var targetIndex = Math.max(0, Math.min(panels.length - 1, index));
				var panel = panels[targetIndex];
				var left = panel.offsetLeft - (track.clientWidth - panel.offsetWidth) / 2;
				if (
					!reducedMotion &&
					"scrollBehavior" in document.documentElement.style &&
					typeof track.scrollTo === "function"
				) {
					track.scrollTo({ left: left, behavior: "smooth" });
				} else {
					track.scrollLeft = left;
				}
				updatePathState(targetIndex);
			};

			track.addEventListener(
				"scroll",
				function () {
					if (scrollFrame) window.cancelAnimationFrame(scrollFrame);
					scrollFrame = window.requestAnimationFrame(function () {
						var center = track.scrollLeft + track.clientWidth / 2;
						var closest = 0;
						var distance = Infinity;
						panels.forEach(function (panel, index) {
							var panelCenter = panel.offsetLeft + panel.offsetWidth / 2;
							var nextDistance = Math.abs(center - panelCenter);
							if (nextDistance < distance) {
								distance = nextDistance;
								closest = index;
							}
						});
						updatePathState(closest);
					});
				},
				{ passive: true }
			);

			if (previous)
				previous.addEventListener("click", function () {
					scrollToPath(current - 1);
				});
			if (next)
				next.addEventListener("click", function () {
					scrollToPath(current + 1);
				});
			dots.forEach(function (dot, index) {
				dot.addEventListener("click", function () {
					scrollToPath(index);
				});
			});
			track.addEventListener("keydown", function (event) {
				if (event.target !== track) return;
				if (event.key === "ArrowRight") {
					event.preventDefault();
					scrollToPath(current + 1);
				}
				if (event.key === "ArrowLeft") {
					event.preventDefault();
					scrollToPath(current - 1);
				}
			});
			updatePathState(0);
		});

		document.querySelectorAll("[data-eb-tabs]").forEach(function (root) {
			root.querySelectorAll("[data-eb-tab]").forEach(function (tab) {
				tab.addEventListener("click", function () {
					var key = tab.getAttribute("data-eb-tab");
					setActive(Array.from(root.querySelectorAll("[data-eb-tab]")), tab);
					root.querySelectorAll("[data-eb-panel]").forEach(function (panel) {
						panel.classList.toggle(
							"is-active",
							panel.getAttribute("data-eb-panel") === key
						);
					});
				});
			});
		});

		document.querySelectorAll("[data-eb-demo-tab]").forEach(function (tab) {
			tab.addEventListener("click", function () {
				var demo = tab.closest(".eb-demo-window");
				var key = tab.getAttribute("data-eb-demo-tab");
				if (!demo) return;
				setActive(Array.from(demo.querySelectorAll("[data-eb-demo-tab]")), tab);
				demo.querySelectorAll("[data-eb-demo-panel]").forEach(function (panel) {
					panel.classList.toggle(
						"is-active",
						panel.getAttribute("data-eb-demo-panel") === key
					);
				});
			});
		});

		document.querySelectorAll("[data-eb-product-tour]").forEach(function (root) {
			var order = ["dashboard", "sales", "cash", "review", "reports"];
			var titles = {
				dashboard: "Dashboard",
				sales: "Sales & Receivables",
				cash: "Cash & Bank",
				review: "Review",
				reports: "Reports",
			};
			var currentStep = 0;
			var navItems = Array.from(root.querySelectorAll("[data-eb-product-nav]"));
			var screens = Array.from(root.querySelectorAll("[data-eb-product-screen]"));
			var copyPanels = Array.from(root.querySelectorAll("[data-eb-tour-copy]"));
			var title = root.querySelector("[data-eb-demo-title]");
			var count = root.querySelector("[data-eb-tour-count]");
			var progress = root.querySelector("[data-eb-tour-progress]");
			var previous = root.querySelector("[data-eb-tour-prev]");
			var next = root.querySelector("[data-eb-tour-next]");
			var toast = root.querySelector("[data-eb-demo-toast]");
			var toastTimer = null;

			var showToast = function (message) {
				if (!toast) return;
				window.clearTimeout(toastTimer);
				toast.textContent = message;
				toast.hidden = false;
				toast.classList.add("is-visible");
				toastTimer = window.setTimeout(function () {
					toast.classList.remove("is-visible");
					toast.hidden = true;
				}, 2600);
			};

			var showScreen = function (key) {
				var index = order.indexOf(key);
				if (index < 0) return;
				currentStep = index;
				navItems.forEach(function (item) {
					var active = item.getAttribute("data-eb-product-nav") === key;
					item.classList.toggle("is-active", active);
					item.setAttribute("aria-current", active ? "page" : "false");
				});
				screens.forEach(function (screen) {
					var active = screen.getAttribute("data-eb-product-screen") === key;
					screen.classList.toggle("is-active", active);
					screen.hidden = !active;
				});
				copyPanels.forEach(function (panel) {
					var active = panel.getAttribute("data-eb-tour-copy") === key;
					panel.classList.toggle("is-active", active);
					panel.hidden = !active;
				});
				if (title) title.textContent = titles[key];
				if (count) count.textContent = currentStep + 1 + " of " + order.length;
				if (progress)
					progress.style.width = ((currentStep + 1) / order.length) * 100 + "%";
				if (previous) previous.disabled = currentStep === 0;
				if (next) next.disabled = currentStep === order.length - 1;
			};

			navItems.forEach(function (item) {
				item.addEventListener("click", function () {
					showScreen(item.getAttribute("data-eb-product-nav"));
				});
			});
			root.querySelectorAll("[data-eb-jump]").forEach(function (item) {
				item.addEventListener("click", function () {
					showScreen(item.getAttribute("data-eb-jump"));
				});
			});
			if (previous)
				previous.addEventListener("click", function () {
					showScreen(order[currentStep - 1]);
				});
			if (next)
				next.addEventListener("click", function () {
					showScreen(order[currentStep + 1]);
				});

			var setLocalTabs = function (
				tabSelector,
				panelSelector,
				keyAttribute,
				panelAttribute
			) {
				root.querySelectorAll(tabSelector).forEach(function (tab) {
					tab.addEventListener("click", function () {
						var key = tab.getAttribute(keyAttribute);
						var tabRoot = tab.parentElement;
						if (tabRoot)
							setActive(Array.from(tabRoot.querySelectorAll(tabSelector)), tab);
						root.querySelectorAll(panelSelector).forEach(function (panel) {
							var active = panel.getAttribute(panelAttribute) === key;
							panel.classList.toggle("is-active", active);
							panel.hidden = !active;
						});
					});
				});
			};

			setLocalTabs(
				"[data-eb-cash-tab]",
				"[data-eb-cash-panel]",
				"data-eb-cash-tab",
				"data-eb-cash-panel"
			);
			setLocalTabs(
				"[data-eb-report-tab]",
				"[data-eb-report-panel]",
				"data-eb-report-tab",
				"data-eb-report-panel"
			);
			setLocalTabs(
				"[data-eb-review-tab]",
				"[data-eb-review-panel]",
				"data-eb-review-tab",
				"data-eb-review-panel"
			);

			var invoiceCreated = false;
			var setInvoiceFilter = function (filter) {
				root.querySelectorAll("[data-eb-invoice-filter]").forEach(function (button) {
					button.classList.toggle(
						"is-active",
						button.getAttribute("data-eb-invoice-filter") === filter
					);
				});
				root.querySelectorAll("[data-eb-invoice-state]").forEach(function (row) {
					var isNew = row.hasAttribute("data-eb-new-invoice");
					row.hidden =
						(isNew && !invoiceCreated) ||
						(filter === "overdue" &&
							row.getAttribute("data-eb-invoice-state") !== "overdue");
				});
			};
			root.querySelectorAll("[data-eb-invoice-filter]").forEach(function (button) {
				button.addEventListener("click", function () {
					setInvoiceFilter(button.getAttribute("data-eb-invoice-filter"));
				});
			});

			var dialog = root.querySelector("[data-eb-invoice-dialog]");
			var openDialog = function () {
				if (!dialog) return;
				if (typeof dialog.showModal === "function") dialog.showModal();
				else dialog.setAttribute("open", "");
			};
			var closeDialog = function () {
				if (!dialog) return;
				if (typeof dialog.close === "function") dialog.close();
				else dialog.removeAttribute("open");
			};
			root.querySelectorAll("[data-eb-open-invoice]").forEach(function (button) {
				button.addEventListener("click", openDialog);
			});
			root.querySelectorAll("[data-eb-close-dialog]").forEach(function (button) {
				button.addEventListener("click", closeDialog);
			});
			if (dialog) {
				dialog.addEventListener("click", function (event) {
					if (event.target === dialog) closeDialog();
				});
			}
			var invoiceForm = root.querySelector("[data-eb-invoice-form]");
			if (invoiceForm) {
				invoiceForm.addEventListener("submit", function (event) {
					event.preventDefault();
					invoiceCreated = true;
					var activity = root.querySelector("[data-eb-created-activity]");
					if (activity) activity.hidden = false;
					closeDialog();
					showScreen("sales");
					setInvoiceFilter("all");
					showToast("Sample draft created. Nothing was saved.");
				});
			}

			var confirmMatch = root.querySelector("[data-eb-confirm-match]");
			if (confirmMatch) {
				confirmMatch.addEventListener("click", function () {
					var card = root.querySelector("[data-eb-recon-card]");
					var success = root.querySelector("[data-eb-recon-success]");
					if (card) card.classList.add("is-matched");
					if (success) success.hidden = false;
					confirmMatch.textContent = "Matched";
					confirmMatch.disabled = true;
					showToast("Match confirmed in the fictional walkthrough.");
				});
			}
			var runMatching = root.querySelector("[data-eb-run-matching]");
			if (runMatching) {
				runMatching.addEventListener("click", function () {
					showToast(
						confirmMatch && confirmMatch.disabled
							? "No unmatched sample items remain in this view."
							: "Matching refreshed. One strong suggestion found."
					);
				});
			}

			var approve = root.querySelector("[data-eb-approve]");
			if (approve) {
				approve.addEventListener("click", function () {
					var row = root.querySelector("[data-eb-approval-row]");
					var status = root.querySelector("[data-eb-approval-status]");
					var reviewCount = root.querySelector("[data-eb-review-count]");
					if (row) row.classList.add("is-approved");
					if (status) {
						status.textContent = "Approved";
						status.classList.remove("eb-status-warn");
						status.classList.add("eb-status-good");
					}
					if (reviewCount) reviewCount.textContent = "1";
					approve.textContent = "Approved";
					approve.disabled = true;
					showToast("Sample approval completed. Nothing was saved.");
				});
			}

			root.querySelectorAll("[data-eb-demo-feedback]").forEach(function (button) {
				button.addEventListener("click", function () {
					showToast(button.getAttribute("data-eb-demo-feedback"));
				});
			});

			var exportButton = root.querySelector("[data-eb-export-report]");
			if (exportButton) {
				exportButton.addEventListener("click", function () {
					var report = root.querySelector("[data-eb-report-panel].is-active");
					var key = report ? report.getAttribute("data-eb-report-panel") : "profit";
					var rows = {
						profit: "Account,Amount\nRevenue,62800\nExpenses,37450\nOperating Profit,25350\n",
						balance:
							"Account,Amount\nCash and Bank,48240\nReceivables,12860\nInventory,18400\nTotal Assets,79500\nPayables,8420\nOwner Equity,71080\n",
						aging: "Bucket,Amount\nCurrent,6200\n1-30 days,4820\n31-60 days,1840\n61+ days,0\n",
					};
					var blob = new Blob([rows[key]], { type: "text/csv;charset=utf-8" });
					var url = URL.createObjectURL(blob);
					var link = document.createElement("a");
					link.href = url;
					link.download = "easybooks-fictional-" + key + ".csv";
					document.body.appendChild(link);
					link.click();
					link.remove();
					URL.revokeObjectURL(url);
					showToast("Fictional report exported as CSV.");
				});
			}

			showScreen(order[0]);
		});

		document.querySelectorAll("[data-eb-bookkeeping-rhythm]").forEach(function (root) {
			var tabs = Array.from(root.querySelectorAll("[data-eb-rhythm-tab]"));
			var panels = Array.from(root.querySelectorAll("[data-eb-rhythm-panel]"));

			var showStage = function (key, shouldFocus) {
				tabs.forEach(function (tab) {
					var active = tab.getAttribute("data-eb-rhythm-tab") === key;
					tab.classList.toggle("is-active", active);
					tab.setAttribute("aria-selected", String(active));
					tab.setAttribute("tabindex", active ? "0" : "-1");
					if (active && shouldFocus) tab.focus();
				});
				panels.forEach(function (panel) {
					var active = panel.getAttribute("data-eb-rhythm-panel") === key;
					panel.classList.toggle("is-active", active);
					panel.hidden = !active;
				});
			};

			tabs.forEach(function (tab, index) {
				tab.addEventListener("click", function () {
					showStage(tab.getAttribute("data-eb-rhythm-tab"), false);
				});
				tab.addEventListener("keydown", function (event) {
					if (event.key !== "ArrowLeft" && event.key !== "ArrowRight") return;
					event.preventDefault();
					var direction = event.key === "ArrowRight" ? 1 : -1;
					var nextIndex = (index + direction + tabs.length) % tabs.length;
					showStage(tabs[nextIndex].getAttribute("data-eb-rhythm-tab"), true);
				});
			});

			document.querySelectorAll("[data-eb-rhythm-jump]").forEach(function (button) {
				button.addEventListener("click", function () {
					showStage(button.getAttribute("data-eb-rhythm-jump"), false);
					root.scrollIntoView({ behavior: reducedMotion ? "auto" : "smooth" });
				});
			});

			var matchButton = root.querySelector(".eb-match-visual button");
			if (matchButton) {
				matchButton.addEventListener("click", function () {
					matchButton.textContent = "Matched";
					matchButton.disabled = true;
					matchButton.parentElement.classList.add("is-matched");
				});
			}

			if (tabs.length) showStage(tabs[0].getAttribute("data-eb-rhythm-tab"), false);
		});

		document.querySelectorAll("[data-eb-pricing]").forEach(function (root) {
			var status = root.querySelector("[data-eb-plan-status]");
			var planButtons = Array.from(root.querySelectorAll("[data-eb-plan-select]"));
			var dialog = root.querySelector("[data-eb-plan-dialog]");
			var confirmForm = root.querySelector("[data-eb-plan-confirm-form]");
			var consent = root.querySelector("[data-eb-plan-consent]");
			var pendingButton = null;

			var setPlanStatus = function (message, state) {
				if (!status) return;
				status.hidden = false;
				status.className = "eb-plan-status is-" + state;
				status.textContent = message;
				status.scrollIntoView({ block: "nearest" });
			};

			var setPlanBusy = function (busy, activeButton) {
				planButtons.forEach(function (button) {
					button.disabled = busy;
				});
				if (activeButton) {
					if (!activeButton.getAttribute("data-eb-label")) {
						activeButton.setAttribute("data-eb-label", activeButton.textContent);
					}
					activeButton.textContent = busy
						? "Activating..."
						: activeButton.getAttribute("data-eb-label");
				}
			};

			var closePlanDialog = function () {
				if (!dialog) return;
				if (typeof dialog.close === "function") dialog.close();
				else dialog.removeAttribute("open");
				if (consent) consent.checked = false;
			};

			var activatePlan = function (plan, button) {
				setPlanBusy(true, button);
				setPlanStatus("Activating your plan in ERPNext...", "loading");
				postToFrappe(
					"selfmade_books.api.marketing.select_subscription_plan",
					{ plan: plan },
					function (result) {
						if (result.requires_contact && result.contact_url) {
							window.location.assign(result.contact_url);
							return;
						}
						setPlanBusy(false, button);
						if (!result.success) {
							setPlanStatus(result.message || "A plan change needs review.", "notice");
							return;
						}
						setPlanStatus(result.message || "Your plan is active.", "success");
						button.textContent = "Current plan";
						button.disabled = true;
						button.closest(".eb-plan-card").classList.add("is-current");
					},
					function (message) {
						setPlanBusy(false, button);
						setPlanStatus(message, "error");
					}
				);
			};

			planButtons.forEach(function (button) {
				button.addEventListener("click", function () {
					var plan = button.getAttribute("data-eb-plan-select");
					if (plan !== "pro" || !dialog) {
						activatePlan(plan, button);
						return;
					}
					pendingButton = button;
					if (typeof dialog.showModal === "function") dialog.showModal();
					else dialog.setAttribute("open", "");
				});
			});

			root.querySelectorAll("[data-eb-plan-dialog-close]").forEach(function (button) {
				button.addEventListener("click", closePlanDialog);
			});
			if (dialog) {
				dialog.addEventListener("click", function (event) {
					if (event.target === dialog) closePlanDialog();
				});
			}
			if (confirmForm) {
				confirmForm.addEventListener("submit", function (event) {
					event.preventDefault();
					if (!confirmForm.checkValidity()) {
						if (confirmForm.reportValidity) confirmForm.reportValidity();
						return;
					}
					var button = pendingButton;
					closePlanDialog();
					if (button) activatePlan("pro", button);
				});
			}
		});

		document.querySelectorAll("[data-eb-contact]").forEach(function (root) {
			var form = root.querySelector("[data-eb-contact-form]");
			var submit = root.querySelector("[data-eb-contact-submit]");
			var status = root.querySelector("[data-eb-contact-status]");
			var context = root.querySelector("[data-eb-contact-context]");
			var select = root.querySelector("[data-eb-inquiry-select]");
			var message = form ? form.querySelector("textarea[name='message']") : null;
			var count = root.querySelector("[data-eb-message-count]");
			var choices = Array.from(root.querySelectorAll("[data-eb-inquiry-choice]"));
			var inquiryTypes = [
				"general",
				"product",
				"pricing",
				"bookkeeping",
				"support",
				"partnership",
			];

			var setInquiry = function (value) {
				if (inquiryTypes.indexOf(value) < 0) return;
				if (select) {
					select.value = value;
				}
				choices.forEach(function (choice) {
					var active = choice.getAttribute("data-eb-inquiry-choice") === value;
					choice.classList.toggle("is-active", active);
					choice.setAttribute("aria-pressed", String(active));
				});
			};

			var setContactStatus = function (text, state) {
				if (!status) return;
				status.hidden = false;
				status.className = "eb-contact-status is-" + state;
				status.textContent = text;
			};

			choices.forEach(function (choice) {
				choice.addEventListener("click", function () {
					setInquiry(choice.getAttribute("data-eb-inquiry-choice"));
					if (message) message.focus();
				});
			});
			if (select) {
				select.addEventListener("change", function () {
					setInquiry(select.value);
				});
			}
			if (message && count) {
				var updateCount = function () {
					count.textContent = message.value.length;
				};
				message.addEventListener("input", updateCount);
				updateCount();
			}

			var topic = queryValue("topic");
			var plan = queryValue("plan").toLowerCase();
			if (topic) setInquiry(topic);
			if ((plan === "free" || plan === "pro") && context) {
				setInquiry("pricing");
				context.hidden = false;
				context.textContent = "Plan context: EasyBooks " + (plan === "pro" ? "Pro" : "Free");
				if (message && !message.value) {
					message.value =
						"I am interested in the EasyBooks " +
						(plan === "pro" ? "Pro" : "Free") +
						" plan. Please help me understand the next step for account setup.";
					if (count) count.textContent = message.value.length;
				}
			}

			if (!form) return;
			form.addEventListener("submit", function (event) {
				event.preventDefault();
				if (!form.checkValidity()) {
					if (form.reportValidity) form.reportValidity();
					return;
				}

				var fields = form.elements;
				var data = {
					full_name: fields.full_name.value,
					email: fields.email.value,
					organization: fields.organization.value,
					inquiry_type: fields.inquiry_type.value,
					message: fields.message.value,
					website: fields.website.value,
				};
				submit.disabled = true;
				submit.textContent = "Sending...";
				setContactStatus("Sending your inquiry...", "loading");
				postToFrappe(
					"selfmade_books.api.marketing.submit_contact_inquiry",
					data,
					function (result) {
						submit.disabled = false;
						submit.textContent = "Send inquiry";
						setContactStatus(result.message || "Thanks. Your message has been received.", "success");
						form.reset();
						setInquiry("general");
						if (count) count.textContent = "0";
					},
					function (errorMessage) {
						submit.disabled = false;
						submit.textContent = "Send inquiry";
						setContactStatus(errorMessage, "error");
					}
				);
			});
		});
	});
})();
